// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { alertsClasses as myClasses } from "src/controllers/alerts";

import { Classes, MPDButton, MPDIcon } from "src/mpd-library";

import {
  ChannelBox,
  MoreInfo,
  TextArea
} from "src/controllers/alerts/components";

import { FloatingInput } from 'src/components';

import { HTMLDivProps, Text } from "@blueprintjs/core";

import "./styles.css";

export interface IMessageDetailsProps extends HTMLDivProps {
  messageDetails: any;
  multiMedia: any;
  onMessageDetailsInputChanged(event: any, type: string): void;
  onRemoveFile(event: any, name: string): void;
  onToggleMoreInfo(event: any, type: string): void;
}

interface IMessageDetailsState {
  addInstructions?: boolean;
}

export class MessageDetails extends React.Component<
  IMessageDetailsProps,
  IMessageDetailsState
> {
  public constructor(props: IMessageDetailsProps) {
    super(props);
    this.state = {
      addInstructions: false
    };
  }

  public render() {
    const {
      className,
      messageDetails,
      multiMedia,
      onMessageDetailsInputChanged,
      onRemoveFile,
      onToggleMoreInfo
    } = this.props;

    const { files } = multiMedia;
    const { addInstructions } = this.state;

    const {
      description,
      headline,
      instructions,
      moreInfo,
      wea
    } = messageDetails;

    const classes = classNames(
      myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER,
      "message-details-container",
      className
    );

    return (
      <div className={classes}>
        <div className={myClasses.ALERTS_CONTENT_COMPOSE_SUBTITLE_CONTAINER}>
          <Text className={myClasses.ALERTS_CONTENT_COMPOSE_SUBTITLE}>
            message details
          </Text>
          <MoreInfo onClick={e => onToggleMoreInfo(e, "messageDetails")} />
        </div>
        <div className={myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_INNER_CONTAINER}>
          <div
            className={myClasses.ALERTS_CONTENT_COMPOSE_CHANNEL_BOX_CONTAINER}
          >
            <FloatingInput
              autoCapitalize="none"
              autoCorrect="none"
              floatingType="compose"
              value={wea.value}
              onChange={e => onMessageDetailsInputChanged(e, "wea")}
              placeholder="wea text"
              tabIndex={1}
              maxCounter={128}
            />
            <Text
              className={classNames(
                myClasses.ALERTS_CONTENT_COMPOSE_MORE_INFO,
                moreInfo && Classes.ACTIVE
              )}
            >
              This can be a hint that shows the user what to put here when they
              select the “i” button next to Message Details. On mobile, this
              could show up below the input
            </Text>
          </div>
          <div
            className={myClasses.ALERTS_CONTENT_COMPOSE_CHANNEL_BOX_CONTAINER}
          >
            <FloatingInput
              autoCapitalize="none"
              autoCorrect="none"
              floatingType="compose"
              value={headline.value}
              onChange={e => onMessageDetailsInputChanged(e, "headline")}
              placeholder="headline"
              tabIndex={1}
              maxCounter={160}
            />
            <Text
              className={classNames(
                myClasses.ALERTS_CONTENT_COMPOSE_MORE_INFO,
                moreInfo && Classes.ACTIVE
              )}
            >
              This can be a hint that shows the user what to put here when they
              select the “i” button next to Message Details. On mobile, this
              could show up below the input
            </Text>
          </div>
          <div
            className={myClasses.ALERTS_CONTENT_COMPOSE_CHANNEL_BOX_CONTAINER}
          >
            <TextArea
              autoCapitalize="none"
              autoCorrect="none"
              floatingType="compose"
              value={description.value}
              onChange={e => onMessageDetailsInputChanged(e, "description")}
              placeholder="description"
              tabIndex={1}
              type="mpd-static"
              rows={5}
              maxCounter={360}
            />
            <Text
              className={classNames(
                myClasses.ALERTS_CONTENT_COMPOSE_MORE_INFO,
                moreInfo && Classes.ACTIVE
              )}
            >
              This can be a hint that shows the user what to put here when they
              select the “i” button next to Message Details. On mobile, this
              could show up below the input
            </Text>
          </div>
          <div
            className={myClasses.ALERTS_CONTENT_COMPOSE_CHANNEL_BOX_CONTAINER}
          >
            {addInstructions ? (
              <FloatingInput
                className={classNames(addInstructions && Classes.ACTIVE)}
                autoCapitalize="none"
                autoCorrect="none"
                floatingType="compose"
                value={instructions.value}
                onChange={e => onMessageDetailsInputChanged(e, "instructions")}
                placeholder="instructions"
                tabIndex={1}
                maxCounter={160}
              />
            ) : (
              <ChannelBox
                className={classNames("input-channel-box")}
                onClick={e => this.setState({ addInstructions: true })}
                jsxElement={
                  <Text className="add-instructions-text">
                    ADD INSTRUCTIONS <span>(optional)</span>
                  </Text>
                }
                title="Add Instructions"
              />
            )}
            <Text
              className={classNames(
                myClasses.ALERTS_CONTENT_COMPOSE_MORE_INFO,
                moreInfo && Classes.ACTIVE
              )}
            >
              This can be a hint that shows the user what to put here when they
              select the “i” button next to Message Details. On mobile, this
              could show up below the input
            </Text>
            <div className="files-container">
              {files.map(
                (element: any, index: number) =>
                  element !== null && element.id.includes("image") ? (
                    <div className="images-placeholder-container" key={index}>
                      <div className="placeholder-image">
                        <img src={element.src} />
                      </div>
                      <MPDButton
                        className="exit"
                        onClick={e => onRemoveFile(e, element.name)}
                        name="compose-images-exit"
                      />
                    </div>
                  ) : (
                    element !== null && (
                      <div className="files-placeholder-container" key={index}>
                        <MPDIcon
                          name="fil-audio"
                          className={classNames(
                            "left-icon",
                            element.id === "audio" && Classes.ACTIVE
                          )}
                        />
                        <MPDIcon
                          name="fil-movie"
                          className={classNames(
                            "left-icon",
                            element.id === "video" && Classes.ACTIVE
                          )}
                        />
                        <MPDIcon
                          name="fil-attach"
                          className={classNames(
                            "left-icon",
                            element.id === "document" && Classes.ACTIVE
                          )}
                        />
                        <Text className="name"> {element.name} </Text>
                        <Text className="size"> {element.size} MB </Text>
                        <MPDButton
                          className="exit"
                          onClick={e => onRemoveFile(e, element.name)}
                          name="compose-files-exit"
                        />
                      </div>
                    )
                  )
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/compose-message/message-details.tsx